export const ACTION_TYPES = {
	INITIALIZE_PRODUCT: "INITIALIZE_PRODUCT",
	SET_QUANTITY: "SET_QUANTITY",
	SET_VARIANTS: "SET_VARIANTS",
	SET_FEES: "SET_FEES",
	SET_LOADING_VARIANTS: "SET_LOADING_VARIANTS",
	SELECT_VARIANT: "SELECT_VARIANT",
	SET_VALIDATION_ERRORS: "SET_VALIDATION_ERRORS",
	SET_ERROR: "SET_ERROR",
	SET_ADDING: "SET_ADDING",
	RESET_FORM: "RESET_FORM",
	SET_SUCCESS: "SET_SUCCESS",
} as const;
